import * as React from "react";

export default function Footer() {
    return (
        <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
            <p className="col-md-4 mb-0 text-body-secondary">© 2023 The University of Nottingham Rambling & Hiking
                Club.</p>
        </footer>
    )
}